<div #modalContainer [id]="id()" tabindex="-1" role="dialog" aria-modal="true" aria-labelledby="message-detail-modal-title" (keydown.escape)="closeModal()" class="fixed top-0 left-0 right-0 z-50 hidden w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full"
    (click)="$event.preventDefault()">
    <div class="relative w-fit rounded-lg bg-primary-purple-light-2 p-8">
        <div class="flex items-center">
          <div>
            <p id="message-detail-modal-title" class="font-bold text-lg text-neutrals-grey-06">
              {{ literalService.get('messages.modal.details.title', true) }}:
            </p>
          </div>
          <button (click)="closeModal()" type="button"
            class="absolute right-8 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ml-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
           >
            <img [src]="images.close" class="h-6 w-6" />
          </button>
        </div>
        <section class="pt-6">
          <div class="flex gap-6">
            <app-detail
              [data]="subjectElement"
              [value]="subjectElement.value"
            ></app-detail>
            <app-detail
              [data]="receiverElement"
              [value]="receiverElement.value"
            ></app-detail>
          </div>
          <div>
            <div class="py-2 h-14">
              <app-input-search [searchValue]="searchValue" [placeholder]="`${literalService.get('search', true)}...`" [width]="'full'" [style]="'secondary'" (submitEventEmitter)="onSearch($event)"></app-input-search>
            </div>
            <div class="flex justify-between items-center py-3">
              <div class="flex gap-2 items-center">
                <img [src]="selectedStatus === MessageStatus.FAILED ? images.messages.failedMessageSent : images.messages.successMessageSent" alt="messages-send-status" class="w-6 h-6" [ngClass]="{'filter-secondary-green': selectedStatus === MessageStatus.SUCCESS, 'filter-secondary-red': selectedStatus === MessageStatus.FAILED}" />
                <span class="text-base">
                  {{ literalService.get(`messages.modal.details.${selectedStatus.toLowerCase()}Messages`, true) }}
                  {{ `(${list()?.pagination?.totalElements})` }}
                </span>
              </div>
              <app-custom-toggle
                [id]="'message-detail-toggle'"
                [selectedValue]="selectedStatus"
                [options]="messageStatusToggleOptions"
                [small]="true"
                (action)="onChangeMessageStatus()"
              />
            </div>
            <div>
              @for(user of list()?.value; track $index; let userIdx = $index) {
                <div class="messageDetailRow grid grid-cols-4 border py-2 px-4 bg-white">
                  <div class="flex justify-center items-center gap-3 col-span-1 border-r" >
                    @for(channel of MessageChannels; track $index; let channelIdx = $index) {
                      <img [src]="getChannelIcon(channel.icon)" [alt]="`${channel}-${$index}`" [ngClass]="checkChannelStatus(channel.icon, userIdx)" [tooltip]="getTooltipText(channel.icon, userIdx)" [position]="TooltipPosition.BELOW" [visibleTooltip]="getChannelStatus(channel.icon, userIdx) === MessageStatus.SUCCESS"/>
                    }
                  </div>
                  <div class="flex justify-center items-center cursor-pointer col-span-3 gap-2 text-base" (click)="userClickEmitter.emit(user.receiver?.id)">
                    {{ user?.receiver?.name }}
                    <img [src]="images.externalLink" alt="external-link" />
                  </div>
                </div>
              }
            </div>
          </div>
        </section>
        @if (list()?.value?.length > 0) {
          <div class="relative pt-4 h-10">
            <app-pagination [pagination]="list()?.pagination" [right]="false" (changePage)="onChangePage($event)"/>
          </div>
        }
    </div>
</div>